<style lang="less">
.tool-sign-method-wrapper {
  .form-wrapper {
    min-width: 300px;
  }
  .response-data-area .line:first-child {
    margin: 4px 0 !important;
  }
  .response-data-area .line {
    margin-top: 1px !important;
    margin-bottom: 1px !important;
  }
  .ivu-form-item-label {
    overflow-wrap: break-word;
  }
  .form-wrapper {
    flex: 1;
  }
  .result-wrapper {
    flex: 1;
    margin-left: 24px;
    .response-wrapper {
      .inner-title {
        height: 20px;
        line-height: 20px;
      }
    }
  }
}
</style>

<template>
  <div class="flex tool-sign-method-wrapper page-content">
    <h1>调用流程</h1>
    <p>
      开放平台的API是基于HTTP协议来调用的, 流程如下：<span style="margin-left: 5px;">填充参数 &gt; 生成签名 &gt; 拼装HTTP请求 &gt; 发起HTTP请求&gt; 得到HTTP响应 &gt; 解释json/xml结果</span>
    </p>

    <h1>调用入口</h1>
    <p>调用API的服务URL地址，开放平台目前只提供了正式环境：{{$store.state.app.config.apiUrl}}</p>

    <h1>签名算法</h1>
    <p>为了防止API调用过程中被黑客恶意篡改，调用任何一个API都需要携带签名，ME3服务端会根据请求参数，对签名进行验证，签名不合法的请求将会被拒绝。目前只支持MD5(sign_method=md5)签名算法，签名大体过程如下：</p>
    <ul>
      <li>
        对所有API请求参数（包括公共参数和业务参数，但除去sign参数和byte[]类型的参数, <strong>注意:请求地址上的app_act参数也不参与签名</strong>），根据参数名称的
        <a href="http://www.asciima.com/">ASCII</a>码表的顺序排序。如：foo:1, bar:2, foo_bar:3, foobar:4排序后的顺序是bar:2, foo:1, foo_bar:3, foobar:4。
      </li>
      <li>将排序好的参数名和参数值拼装在一起，根据上面的示例得到的结果为：bar2foo1foo_bar3foobar4。</li>
      <li>把拼装好的字符串采用utf-8编码，在拼装的字符串前后加上app的secret后，进行MD5加密，如：md5(secret+bar2foo1foo_bar3foobar4+secret)。</li>
      <li>将摘要得到的字符串字母转为大写得到签名。</li>
    </ul>

    <h1 id="s5">调用示例</h1>
    <p>
      以
      <a href="https://mc3_open.sqzw.com/#/doc">base.shop.get_list</a>调用为例，具体步骤如下：
    </p>
    <p>
      <strong>1. 设置参数值</strong>
    </p>
    <p>公共参数：</p>
    <ul>
      <li>method = “base.shop.get_list”</li>
      <li>format = “json”</li>
      <li>key = “abcd123456”</li>
      <li>timestamp = “2020-01-01 12:00:00”</li>
      <li>v = “2.0”</li>
      <li>sign_method = “md5”</li>
      <li>data = “{"lylx":1,"status":1}”</li>
    </ul>
    <p>业务参数：（注意 业务参数通过json格式编码后放在data参数中）</p>
    <ul>
      <li>lylx = “1”</li>
      <li>status = “1”</li>
    </ul>
    <p>
      <strong>2. 按ASCII顺序排序</strong>
    </p>
    <ul>
      <li>data = “{"lylx":1,"status":1}”</li>
      <li>format = “json”</li>
      <li>key = “abcd123456”</li>
      <li>sign_method = “md5”</li>
      <li>timestamp = “2020-01-01 12:00:00”</li>
      <li>v = “2.0”</li>
    </ul>
    <p>
      <strong>3. 拼接参数名与参数值</strong>
    </p>
    <pre><code class="http hljs"><span
  class="hljs-attribute"
>
data{"lylx":1,"status":1}formatjsonkeyabcd123456methodbase.shop.get_listsign_methodmd5timestamp2020-01-01 12:00:00v2.0
</span></code></pre>
    <p>
      <strong>4. 生成签名</strong>
      <br />假设app的secret为hellome3，则签名结果为：md5(hellome3+按顺序拼接好的参数名与参数值+hellome3)) = “935f3119f956fd451eb1e198fff46b0f”
      <br />对签名结果字母转为大写, 得到最终签名：“935F3119F956FD451EB1E198FFF46B0F”
    </p>
    <p>
      <strong>5. 组装HTTP请求</strong>
      <br />将所有参数名和参数值采用utf-8进行URL编码（参数顺序可随意，但必须要包括签名参数），然后通过GET或POST（含byte[]类型参数）发起请求，如：
    </p>
    <pre><code class="http hljs"><span
  class="hljs-attribute"
>
https://mc3.sqzw.com/release/mc3/api/?app_act=webopen&method=base.shop.get_list&format=json&key=abcd123456&timestamp=2020-01-01%2012:00:00&v=2.0&sign_method=md5&data={%22lylx%22:1,%22status%22:1}&sign=935F3119F956FD451EB1E198FFF46B0F
</span></code></pre>
    <h1 id="s6">注意事项</h1>
    <ul>
      <li>所有的请求和响应数据编码皆为utf-8格式，URL里的所有参数名和参数值请做URL编码。如果请求的Content-Type是application/x-www-form-urlencoded，则HTTP Body体里的所有参数值也做URL编码；如果是multipart/form-data格式，每个表单字段的参数值无需编码,但每个表单字段的charset部分需要指定为utf-8。</li>
      <li>参数名与参数值拼装起来的URL长度小于1024个字符时，可以用GET发起请求；参数类型含byte[]类型或拼装好的请求URL过长时，必须用POST发起请求。</li>
    </ul>
  </div>
</template>

<script>

export default {
  name: "tool-sign-method",
  components: {},
  data() {
    return {};
  },
  methods: {
    // 初始化表单验证规则
  }
};
</script>
